import React from 'react'
import { colors } from 'ic-snacks'
import { getSeriesColor, getSeriesAreaColor } from 'legacy/components/DataViz/Charts/utils'
import {
  type ChartSeries,
  SeriesTypes,
  type GroupedSeriesData,
} from 'legacy/components/DataViz/dataViz.types'

export const secondaryLineStyle = {
  data: {
    stroke: getSeriesColor(SeriesTypes.Secondary),
    strokeWidth: 1,
    strokeDasharray: '6 3',
  },
}

export function getScatterStyle(type: ChartSeries['type']) {
  return {
    data: {
      fill: getSeriesColor(type),
      stroke: getSeriesColor(type),
      strokeWidth: 1.5,
    },
  }
}

export function getLineStyle(type: ChartSeries['type']) {
  return {
    data: {
      fill: `url(#gradientStroke-${type})`,
      stroke: getSeriesColor(type),
      strokeWidth: 1.5,
    },
    labels: {
      fill: getSeriesColor(type),
      fontFamily: 'inherit',
    },
  }
}

export function generateLinearGradient({ type }: Pick<GroupedSeriesData, 'type'>) {
  if (type === SeriesTypes.LastPeriod || type === SeriesTypes.Secondary) return null
  const id = `gradientStroke-${type}`
  return (
    <linearGradient key={type} id={id} x1="0%" x2="0%" y1="0%" y2="200%">
      <stop offset="0%" stopColor={getSeriesAreaColor(type)} stopOpacity="0.2" />
      <stop offset="30%" stopColor={colors.WHITE} stopOpacity="0.1" />
    </linearGradient>
  )
}
